import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProfileInfoModule } from 'account/pages/profile-info/profile-info.module';

import { SharedModule } from 'shared/shared.module';
import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './components/account/account.component';

@NgModule({
  declarations: [AccountComponent],
  imports: [
    CommonModule,
    ProfileInfoModule,
    AccountRoutingModule,
    SharedModule,
  ],
})
export class AccountModule {
}
